/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventTitle: NonNullable<unknown> }} Eventisnowliveandvisibletousers7Inputs */

const en_eventisnowliveandvisibletousers7 = /** @type {(inputs: Eventisnowliveandvisibletousers7Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.eventTitle}" is now live and visible to users.`)
};

const de_eventisnowliveandvisibletousers7 = /** @type {(inputs: Eventisnowliveandvisibletousers7Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.eventTitle}“ ist jetzt online und für alle sichtbar.`)
};

/**
* | output |
* | --- |
* | "\"{eventTitle}\" is now live and visible to users." |
*
* @param {Eventisnowliveandvisibletousers7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventisnowliveandvisibletousers7 = /** @type {((inputs: Eventisnowliveandvisibletousers7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventisnowliveandvisibletousers7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventisnowliveandvisibletousers7(inputs)
	return de_eventisnowliveandvisibletousers7(inputs)
});
export { eventisnowliveandvisibletousers7 as "eventIsNowLiveAndVisibleToUsers" }